/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as Sentry from '@sentry/react';
import { withProfiler } from '@sentry/react';
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import rootRoutesConfig from '@fai/friendli-suite/app/routes/app-routes';
import { environment } from '@fai/friendli-suite/shared/environments/environment';

import { HideWrapperAffix } from './hide-wrapper-affix';
import InitCanny from './init-canny';
import InitGTM from './init-gtm';
import InitIntercom from './init-intercom';
import { MSWAffix } from './msw-affix';

/**
 * @url https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/#usage-with-react-router-64-data-api
 */
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

function App() {
  React.useLayoutEffect(() => {
    InitGTM();
    InitCanny();
    InitIntercom();
  }, []);

  const router = sentryCreateBrowserRouter(rootRoutesConfig);

  return (
    <>
      <RouterProvider router={router} />
      <MSWAffix />
      <HideWrapperAffix />
    </>
  );
}

export default withProfiler(App, { name: environment.APP_NAME });
